import { useState, useEffect, useRef } from 'react'

interface BackendPairInfo {
  address: string
  version: 2 | 3
  token0: string
  token1: string
  feeTier: string
  supply: number
  tvlUSD: number
  tvlETH: number
  reserve0: number
  reserve1: number
}

let globalData: BackendPairInfo[] | null = null
let globalError: Error | null = null
let globalLoading = true
let globalFetched = false
const listeners = new Set()

const useBackendPairData = () => {
  const [data, setData] = useState(globalData)
  const [error, setError] = useState(globalError)
  const [loading, setLoading] = useState(globalLoading)
  const listenerRef = useRef<any>()

  useEffect(() => {
    // Create listener function for this hook instance
    const listener = (newData: BackendPairInfo[] | null, newError: Error | null, newLoading: boolean) => {
      setData(newData)
      setError(newError)
      setLoading(newLoading)
    }

    listenerRef.current = listener
    listeners.add(listener)

    // If data hasn't been fetched yet, fetch it
    if (!globalFetched) {
      globalFetched = true

      fetch('https://interface-gateway.ubeswap.org/v1/graphql', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          operationName: 'PairsV3',
          variables: {},
          query: '',
        }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
          }
          return response.json()
        })
        .then((result) => {
          globalData = result
          globalError = null
          globalLoading = false

          // Notify all listeners
          listeners.forEach((l: any) => l(globalData, globalError, globalLoading))
        })
        .catch((err) => {
          globalData = null
          globalError = err
          globalLoading = false

          // Notify all listeners
          listeners.forEach((l: any) => l(globalData, globalError, globalLoading))
        })
    } else {
      // Data already fetched or in progress, sync with global state
      setData(globalData)
      setError(globalError)
      setLoading(globalLoading)
    }

    // Cleanup listener on unmount
    return () => {
      if (listenerRef.current) {
        listeners.delete(listenerRef.current)
      }
    }
  }, [])

  return { data, error, loading }
}

export default useBackendPairData
